
<ng-container *ngIf="{
  level: level$ | async,
  equipment: equipment$ | async
} as pageData">
  <ion-grid>
    <ion-row class="status-row">
      <ion-col>
        <ion-card>
          <ion-card-content class="thin-status-card" *ngIf="currentLocation$ | async as currentLocation; else noGathering">
            <div>
              Gathering from {{ currentLocation.location.name }} for another <strong><app-countdown [duration]="currentLocation.duration"></app-countdown></strong>.
            </div>

            <ion-button color="danger" fill="clear" (click)="cancelGather()" [analyticsClick]="'Gathering:Cancel:' + tradeskill">Cancel</ion-button>
          </ion-card-content>

          <ng-template #noGathering>
            <ion-card-content class="thin-status-card">
              <ng-container *ngIf="{
                currentFishingLocation: currentFishingLocation$ | async,
                currentForagingLocation: currentForagingLocation$ | async,
                currentHuntingLocation: currentHuntingLocation$ | async,
                currentLoggingLocation: currentLoggingLocation$ | async,
                currentMiningLocation: currentMiningLocation$ | async
              } as gatheringLocations">
                <div *ngIf="gatheringLocations.currentFishingLocation">
                  Fishing at {{ gatheringLocations.currentFishingLocation.location.name }} for another <strong><app-countdown [duration]="gatheringLocations.currentFishingLocation.duration"></app-countdown></strong>.
                </div>

                <div *ngIf="gatheringLocations.currentForagingLocation">
                  Foraging at {{ gatheringLocations.currentForagingLocation.location.name }} for another <strong><app-countdown [duration]="gatheringLocations.currentForagingLocation.duration"></app-countdown></strong>.
                </div>

                <div *ngIf="gatheringLocations.currentHuntingLocation">
                  Hunting at {{ gatheringLocations.currentHuntingLocation.location.name }} for another <strong><app-countdown [duration]="gatheringLocations.currentHuntingLocation.duration"></app-countdown></strong>.
                </div>

                <div *ngIf="gatheringLocations.currentLoggingLocation">
                  Logging at {{ gatheringLocations.currentLoggingLocation.location.name }} for another <strong><app-countdown [duration]="gatheringLocations.currentLoggingLocation.duration"></app-countdown></strong>.
                </div>

                <div *ngIf="gatheringLocations.currentMiningLocation">
                  Mining at {{ gatheringLocations.currentMiningLocation.location.name }} for another <strong><app-countdown [duration]="gatheringLocations.currentMiningLocation.duration"></app-countdown></strong>.
                </div>

                <div *ngIf="!gatheringLocations.currentFishingLocation
                         && !gatheringLocations.currentForagingLocation
                         && !gatheringLocations.currentHuntingLocation
                         && !gatheringLocations.currentLoggingLocation
                         && !gatheringLocations.currentMiningLocation">
                  You're not currently doing anything.
                </div>
              </ng-container>
            </ion-card-content>
          </ng-template>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col [sizeMd]="4" *ngFor="let location of locations; trackBy: trackBy">
        <ion-card class="location-card" (mouseenter)="visibleStars[location.name] = true" (mouseleave)="visibleStars[location.name] = false">
          <ion-card-header>
            <ion-card-title>{{ location.name }}</ion-card-title>
            <ion-card-subtitle class="location-description">{{ location.description }}</ion-card-subtitle>
            <ion-card-subtitle>Gives after <strong><app-countdown [duration]="showRealDurationForLocation(location, pageData.equipment || {})"></app-countdown></strong>:</ion-card-subtitle>

            <ion-button class="favorite"
                        color="primary"
                        *ngIf="visibleStars[location.name] || allStarredLocations[location.name]"
                        (click)="toggleFavorite(location, !allStarredLocations[location.name])"
                        fill="clear"
                        size="small"
                        shape="round">

              <ion-icon slot="icon-only"
                        [icon]="allStarredLocations[location.name] ? 'star' : 'star-outline'"></ion-icon>
            </ion-button>
          </ion-card-header>

          <ion-card-content class="resources">
            <div class="resource" *ngFor="let resource of location.resources">
              <app-resource-icon [name]="resource.name"></app-resource-icon>
            </div>
          </ion-card-content>

          <div class="location-footer">

            <ion-button class="user-action" fill="clear" color="warning" *ngIf="(cooldowns$ | async)?.[location.name] as cooldown" disabled="true">
              <ion-spinner color="warning"></ion-spinner>
              <app-countdown [duration]="cooldown"></app-countdown>
            </ion-button>

            <ion-button class="user-action"
                        fill="clear"
                        *ngIf="!(cooldowns$ | async)?.[location.name]"
                        [class.no-skillups]="(pageData.level || 0) >= location.level.max"
                        [disabled]="currentLocation$ | async"
                        (click)="gather(location)"
                        [analyticsClick]="'Gathering:' + tradeskill + ':Gather:' + location.name">
              Gather <span *ngIf="(pageData.level || 0) < location.level.max">&nbsp;(+1 Lv)</span>
            </ion-button>

            <ng-container *ngIf="{
              gatheringWorkers: gatheringWorkers$ | async,
              allocated: workersAllocatedToLocation((gatheringWorkers$ | async)?.workerAllocations ?? [], location)
            } as workerData">
              <div class="workers" *ngIf="location.maxWorkers > 0 && workerData.gatheringWorkers?.hasWorkers">
                <ion-button [color]="workerData.allocated.length > 0 ? 'primary' : 'secondary'"
                            fill="clear"
                            [disabled]="workerData.allocated.length <= 0"
                            (click)="unallocateWorker(location)"
                            ngxTippy="Remove Worker"
                            [analyticsClick]="'Gathering:' + tradeskill + ':RemoveWorker:' + location.name">
                  <ion-icon slot="icon-only" icon="remove"></ion-icon>
                </ion-button>

                <div class="allocated" [class.has-workers]="workerData.allocated.length > 0">{{ workerData.allocated.length | number }} / {{ location.maxWorkers }}</div>

                <ion-button [color]="workerData.allocated.length > 0 ? 'primary' : 'secondary'"
                            fill="clear"
                            [disabled]="workerData.allocated.length >= location.maxWorkers || !workerData.gatheringWorkers?.canAssignWorker"
                            (click)="allocateWorker(location)"
                            ngxTippy="Add Worker"
                            [analyticsClick]="'Gathering:' + tradeskill + ':AddWorker:' + location.name">
                  <ion-icon slot="icon-only" icon="add"></ion-icon>
                </ion-button>

                <div class="progress" *ngIf="workerData.allocated.length > 0" color="primary">
                  <ion-progress-bar [value]="getHighestWorkerProgress(workerData.allocated)"></ion-progress-bar>
                </div>
              </div>
            </ng-container>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
